import { apiGet } from '@/store/api';
import { usePortcallStore } from '@/store/portcallStore';

export async function getVoyage(callId: string | number) {
  const result = await apiGet(`/voyage/call/${callId}`);
  usePortcallStore().setVoyage(result);
}
